import styles from '../../styles/user/Solver.module.scss'
import SolverHeader from '../user/SolverHeader'
import LearningContainer from '../user/LearningContainer'
import SolverLayout from './SolverLayout'

const SolverPage = () => {
  return (
    <SolverLayout>
      <SolverHeader userType="student" />
      <div className={styles.solverPageWrapper}>
        <LearningContainer />
      </div>
    </SolverLayout>
  )
}

export default SolverPage
